/**
 * A page number worth showing or linking to: a whole number from 1 up.
 *
 * The backend sends 0 for a source whose page is unknown (spreadsheets, Word
 * files, or a page the model could not give), and snippets can carry null.
 * Neither is a real page, so callers fall back to the document name alone.
 */
export function knownPage(page: number | null | undefined): number | undefined {
  return typeof page === "number" && Number.isInteger(page) && page > 0 ? page : undefined
}

/** A ", s. 7" suffix for plain-text citations, or "" when the page is unknown. */
export function pageSuffix(page: number | null | undefined): string {
  const known = knownPage(page)
  return known === undefined ? "" : `, s. ${known}`
}
